import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export async function addAndSaveMultiplePurchaser(leadId, form, callback) {
	try {
		let agreementRef = firebaseRef.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/clientInfo/individual'
		);

		let newRef = await agreementRef.push();
		console.log('generated key 1: ', newRef.key);

		await newRef.set({
			firstName: form?.firstName,
			lastName: form?.lastName,
			email: form?.email,
			occupation: form?.occupation,
			phoneNumber: form?.phoneNumber,
			address1: form?.address1,
			address2: form?.address2 || '',
			city: form?.city,
			province: form?.province,
			postalCode: form?.postalCode,
			isPrimary: false,
		});

		callback(newRef.key);
	} catch (error) {
		console.log(error);
	}
}
export async function addMultiplePurchaser(leadId) {
	if (leadId) {
		let formRef = firebaseRef.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/clientInfo/individual'
		);
		let newRef = await formRef.push();

		await newRef.set({
			firstName: '',
			lastName: '',
			email: '',
			occupation: '',
			phoneNumber: '',
			address1: '',
			address2: '',
			city: '',
			province: '',
			postalCode: '',
			isPrimary: false,
		});
	}
}
export async function saveMultiplePurchaser(
	leadId,
	clientInfoKey,
	form,
	callback
) {
	try {
		console.log(
			'🥑 in saveMultiplePurchaser ',
			leadId,
			clientInfoKey,
			form,
			callback
		);
		// let agreementRef =
		// 	clientInfoKey &&
		// 	firebaseRef.ref(
		// 		'/kavtek_agreements/' +
		// 			PROJECT_CODE.projectCode +
		// 			'/' +
		// 			leadId +
		// 			'/clientInfo/individual/' +
		// 			clientInfoKey
		// 	);
		// agreementRef && (await agreementRef.update(form));
		// await agreementRef.on('value', (snapshot) => {
		// 	let data = snapshot.val();
		// 	callback(data);
		// });
	} catch (error) {
		console.log(error);
	}
}
